import { ContentCard } from "@msuite/ui/content-card";
import { TextInput } from "@msuite/ui/form";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import type { ProtocolFormSchema } from "@msuite/utils/schemas";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useProtocolFormContext } from "./context";
import { ProtocolFormSubject } from "./protocol-form-subject";
import { ProtocolFormTypeMenu } from "./protocol-form-type-menu";

export function ProtocolFormBasics() {
	/** Context */
	const methods = useFormContext<ProtocolFormSchema>();
	const { hasType } = useProtocolFormContext();

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<ContentCard
			variant="plain"
			title={t("general.general")}
			icon={icon("Baseline")}
			contentClassName="gap-4"
		>
			<ProtocolFormTypeMenu />
			{hasType ? (
				<React.Fragment>
					<TextInput
						control={methods.control}
						name="title"
						label={t("protocols.title")}
						isRequired={false}
						placeholder={t("protocols.protocol_title")}
						data-cy="protocol-title-input"
					/>
				</React.Fragment>
			) : null}
			<ProtocolFormSubject />
		</ContentCard>
	);
}
